module.exports = __webpack_public_path__ + "img/trans.7313c202.svg";